export var positioningPriorities = {
    top: [
        'top-center',
        'bottom-center',
        'right-top',
        'right-bottom',
        'left-top',
        'left-bottom'
        // 'bottom-responsive'
        // 'top-responsive'
    ],
    bottom: [
        'bottom-center',
        'top-center',
        'right-top',
        'right-bottom',
        'left-top',
        'left-bottom'
        // 'bottom-responsive'
        // 'top-responsive'
    ],
    left: [
        'left-top',
        'left-bottom',
        'right-top',
        'right-bottom',
        'bottom-center',
        'top-center'
        // 'bottom-responsive'
        // 'top-responsive'
    ],
    right: [
        'right-top',
        'right-bottom',
        'left-top',
        'left-bottom',
        'bottom-center',
        'top-center'
        // 'bottom-responsive'
        // 'top-responsive'
    ]
};
//# sourceMappingURL=positioning-priorities.js.map